import Vue from "vue";
import Buefy from "buefy";
import SubDisplay from "./App.vue";


Vue.use(Buefy, {
    defaultIconPack: 'fas',
})

Vue.use(SubDisplay)

if(document.getElementById("subDisplayApp")){
    new Vue({
        render:h=>h(
            SubDisplay,{
                props:{
                    sectionsEndpoint:document.getElementById("subDisplayApp")
                        .getAttribute("sections-endpoint")
                }
            }
        )
    }).$mount("#subDisplayApp")
}